import { Injectable, inject } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Utilities } from "@tylertech/shared-module";

import { IChartCriteria, ProfileSettingViewModel } from "@tylertech/tyler-api-types";
import { ChartDialogComponent, ChartDialogData } from "./dialog";

@Injectable({ providedIn: "root" })
export class ChartDialogService
{
    private readonly matDialog = inject(MatDialog);


    show(settings: ProfileSettingViewModel[], chartName: string): Promise<ProfileSettingViewModel[]>
    {
        const dialogConfig: MatDialogConfig<ChartDialogData> = {
            data: {
                chartName,
                settings
            }
        };
        const dialogRef = this.matDialog.open(ChartDialogComponent, dialogConfig);
        return dialogRef.afterClosed().toPromise();
    }

    showChartParametersDialog(chartTitle: string, originalCriteria: IChartCriteria): Promise<IChartCriteria>
    {
        const chartCriteria = Utilities.deepCopy(originalCriteria);
        return this.show(chartCriteria.Parameters, chartTitle)
            .then((result: ProfileSettingViewModel[]) =>
            {
                if (result?.length)
                {
                    result.forEach(setting =>
                    {
                        if (Array.isArray(setting.Value))
                        {
                            setting.Value = setting.Value.join(",");
                        }
                    });

                    chartCriteria.Parameters = result;
                }
                return chartCriteria;
            });
    }
}
